import { isLive } from "utils/environment";

const eventsRoutes = {
  path: "events",

  // Lazy-load the layout
  lazy: async () => {
    const mod = await import("components/UI/EventsLayout");
    const EventsLayout = mod.default;
    return { Component: EventsLayout };
  },

  children: [
    {
      index: true,
      lazy: async () => {
        const mod = await import("views/Admin/Events");
        const Events = mod.default;
        return { Component: Events };
      },
    },
    // On live, "events/details/:eventId" is served by a direct AdminLayout child
    // (analytics-only page, no EventsLayout) defined in AdminRoutes/index.tsx.
    // Elsewhere it renders the full EventDetails inside EventsLayout here.
    ...(isLive()
      ? []
      : [
          {
            path: "details/:eventId",
            lazy: async () => {
              const mod = await import("views/Admin/Events/EventDetails");
              const EventDetails = mod.default;
              return { Component: EventDetails };
            },
          },
        ]),
  ],
};

export default eventsRoutes;
